// extracted by mini-css-extract-plugin
module.exports = {"mask":"toast_mask__UMtm8","hidden":"toast_hidden__1rgFI","toast":"toast_toast__2ckGu","fadeIn":"toast_fadeIn__3HkI1"};